<template>
  <section class="premium-section">
    <!-- 왼쪽 영역 -->
    <div class="premium-left">
      <div class="premium-text">
        <p class="text-line">3만 3천여 세대 당수·호매실지구,</p>
        <p class="text-line highlight">수원을 대표할 새 도시의 중심에 서다</p>
        <p class="text-eng">SPECIAL <span class="eng-highlight">LOCATION</span></p>
      </div>

      <!-- 프로그레스 바 -->
      <div class="slide-progress">
        <button class="slide-btn" @click="slidePrev">&lt;</button>
        <button class="slide-btn" @click="slideNext">&gt;</button>
        <span class="slide-current">{{ String(displayIndex + 1).padStart(2, '0') }}</span>
        <div class="progress-bar">
          <div class="progress-fill" :key="progressKey" :class="{ 'is-filling': isFilling }"></div>
        </div>
        <span class="slide-total">{{ String(cards.length).padStart(2, '0') }}</span>
      </div>
    </div>

    <!-- 오른쪽 슬라이드 배너 -->
    <div
      class="banner-slider"
      ref="slider"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd"
    >
      <div class="banner-track" :style="trackStyle">
        <div
          v-for="(card, index) in loopCards"
          :key="index"
          class="banner-card"
        >
          <img :src="card.image" :alt="card.title" class="banner-img" />
          <div class="banner-content">
            <h3 class="banner-title">{{ card.title }}</h3>
            <p class="banner-desc">{{ card.desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- VIEW 버튼 (배너 왼쪽 가장자리에 걸침) -->
    <div class="view-btn" :style="viewBtnStyle" @click="$router.push('/location/environment')">
      <svg class="view-rotate-text" viewBox="0 0 160 160">
        <defs>
          <path id="circlePath" d="M80,80 m-65,0 a65,65 0 1,1 130,0 a65,65 0 1,1 -130,0" />
        </defs>
        <text text-anchor="middle">
          <textPath href="#circlePath" startOffset="25%">VIEW MORE</textPath>
        </text>
        <text text-anchor="middle">
          <textPath href="#circlePath" startOffset="75%">VIEW MORE</textPath>
        </text>
      </svg>
      <span class="view-center">VIEW</span>
    </div>

    <!-- 장식 원 -->
    <div class="deco-circle"></div>
  </section>
</template>

<script>
export default {
  name: 'PremiumSection',
  props: {
    items: { type: Array, default: () => [] },
    isActive: { type: Boolean, default: false }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      sliderLeft: 0,
      currentSlide: 0,
      isTransition: true,
      isFilling: false,
      progressKey: 0,
      autoTimer: null,
      touchStartX: 0,
      touchStartY: 0,
      touchDeltaX: 0,
      isSwiping: false,
      cards: [
        {
          title: '새도시 미래 비전',
          desc: '당수 1, 2 지구 호매실지구가 만드는\n약 3만 3천여 세대 서수원 새 도시의 중심',
          image: require('@/assets/premiumsection/slide_location1.jpg')
        },
        {
          title: '서울 빠른 쾌속 교통',
          desc: '수원역 1호선, 신분당선 연장(예정), GTX-C(예정),\n금속IC 등 서울을 빠르게 오가는 교통망',
          image: require('@/assets/premiumsection/slide_location2.jpg')
        },
        {
          title: '초교 품은 안심 교육',
          desc: '당수 1지구 유일 초품아(예정), 수원제일중(이전 예정)\n칠보중, 고, 금곡동 학원가 등 우수한 교육 환경',
          image: require('@/assets/premiumsection/slide_location3.jpg')
        },
        {
          title: '생활 편한 중심 인프라',
          desc: '단지 앞 당수천 수변공원(예정)과 당수공원(예정),\n중심상업지구(예정), 호매실 상권 등 다양한 인프라',
          image: require('@/assets/premiumsection/slide_location4.jpg')
        }
      ]
    }
  },
  computed: {
    loopCards() {
      return [...this.cards, ...this.cards, ...this.cards]
    },
    displayIndex() {
      return this.currentSlide % this.cards.length
    },
    isMobile() {
      return this.windowWidth <= 768
    },
    cardStep() {
      if (!this.isMobile) return 530
      // On mobile: card width (100vw - 48px) + gap (24px) = 100vw - 24px
      return this.windowWidth - 48 + 24
    },
    viewBtnStyle() {
      return {
        left: (this.sliderLeft - 55) + 'px'
      }
    },
    trackStyle() {
      const offset = (this.currentSlide + this.cards.length) * this.cardStep
      return {
        transform: `translateX(-${offset}px)`,
        transition: this.isTransition ? 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)' : 'none'
      }
    }
  },
  mounted() {
    this.startAuto()
    this.startFill()
    this.$nextTick(() => {
      if (this.$refs.slider) {
        this.sliderLeft = this.$refs.slider.getBoundingClientRect().left
      }
    })
    this._onResize = () => {
      this.windowWidth = window.innerWidth
      if (this.$refs.slider) {
        this.sliderLeft = this.$refs.slider.getBoundingClientRect().left
      }
    }
    window.addEventListener('resize', this._onResize)
  },
  beforeUnmount() {
    this.stopAuto()
    window.removeEventListener('resize', this._onResize)
  },
  methods: {
    slideNext() {
      this.isTransition = true
      this.currentSlide++
      this.checkLoop()
      this.resetAuto()
    },
    slidePrev() {
      this.isTransition = true
      this.currentSlide--
      this.checkLoop()
      this.resetAuto()
    },
    checkLoop() {
      const len = this.cards.length
      if (this.currentSlide >= len) {
        setTimeout(() => {
          this.isTransition = false
          this.currentSlide = this.currentSlide - len
        }, 620)
      } else if (this.currentSlide < 0) {
        setTimeout(() => {
          this.isTransition = false
          this.currentSlide = this.currentSlide + len
        }, 620)
      }
    },
    startAuto() {
      this.autoTimer = setInterval(() => {
        this.slideNext()
      }, 3000)
    },
    stopAuto() {
      clearInterval(this.autoTimer)
    },
    startFill() {
      this.isFilling = false
      this.progressKey++
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.isFilling = true
        })
      })
    },
    resetAuto() {
      this.stopAuto()
      this.startFill()
      this.startAuto()
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
      this.touchDeltaX = 0
      this.isSwiping = false
      this.stopAuto()
    },
    onTouchMove(e) {
      const dx = e.touches[0].clientX - this.touchStartX

      // Determine if horizontal swipe (only once)
      if (!this.isSwiping && Math.abs(dx) > 10) {
        this.isSwiping = true
      }

      // If swiping horizontally, prevent vertical scroll
      if (this.isSwiping) {
        e.preventDefault()
        this.touchDeltaX = dx
      }
    },
    onTouchEnd() {
      if (this.isSwiping) {
        const threshold = 50
        if (this.touchDeltaX < -threshold) {
          this.slideNext()
        } else if (this.touchDeltaX > threshold) {
          this.slidePrev()
        }
      }
      this.touchDeltaX = 0
      this.isSwiping = false
      this.startAuto()
    },
    handleScroll(direction) {
      if (direction === 'down') {
        this.$emit('next-section')
      } else {
        this.$emit('prev-section')
      }
    }
  }
}
</script>

<style scoped>
.premium-section {
  height: 100vh;
  background: #fff;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

/* 왼쪽 영역 */
.premium-left {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  padding-left: 120px;
  display: flex;
  flex-direction: column;
  gap: 120px;
}

.text-line {
  font-family: var(--font-family3);
  font-size: 32px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}

.text-line.highlight {
  font-family: var(--font-family3);
  font-weight: 800;
  color: var(--thehue-primary);
}

.text-eng {
  font-family: var(--font-family2);
  font-size: 16px;
  font-weight: 400;
  color: #aaa;
  letter-spacing: 4px;
  margin-top: 20px;
}

.eng-highlight {
  color: var(--thehue-primary);
  font-weight: 500;
}

/* 프로그레스 바 */
.slide-progress {
  display: flex;
  align-items: center;
  gap: 14px;
}

.slide-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #999;
  padding: 4px;
  transition: color 0.2s ease;
}

.slide-btn:hover {
  color: var(--thehue-primary);
}

.slide-current {
  font-family: var(--font-family2);
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-left: 4px;
}

.progress-bar {
  flex: 1;
  height: 2px;
  background: #ddd;
}

.progress-fill {
  height: 100%;
  background: var(--thehue-primary);
  width: 0;
}

.progress-fill.is-filling {
  width: 100%;
  transition: width 3s linear;
}

.slide-total {
  font-family: var(--font-family2);
  font-size: 14px;
  font-weight: 400;
  color: #aaa;
}

/* VIEW 버튼 */
.view-btn {
  position: absolute;
  position: absolute;
  top: 20%;
  z-index: 10;
  pointer-events: auto;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: var(--thehue-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: visible;
}

.view-btn:hover {
  background: var(--sub-color);
}

.view-rotate-text {
  position: absolute;
  width: 155%;
  height: 155%;
  animation: rotate 10s linear infinite;
}

.view-rotate-text text {
  font-family: var(--font-family2);
  font-size: 11px;
  font-weight: 600;
  fill: var(--thehue-primary);
  letter-spacing: 2px;
}

.view-center {
  font-family: var(--font-family2);
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  transition: color 0.3s ease;
}

.view-btn:hover .view-center {
  color: var(--thehue-primary);
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 오른쪽 슬라이드 배너 */
.banner-slider {
  position: relative;
  z-index: 1;
  position: relative;
  margin-left: 100px;
  flex: 1;
  overflow: hidden;
}

.banner-track {
  display: flex;
  gap: 30px;
}

.banner-card {
  position: relative;
  flex-shrink: 0;
  width: 500px;
  height: 600px;
  border-radius: 30px;
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.banner-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px 30px 60px;
}

.banner-title {
  font-family: var(--font-family);
  font-size: 28px;
  font-weight: 700;
  color: var(--thehue-primary);
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.banner-desc {
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 400;
  color: #555;
  line-height: 1.6;
  white-space: pre-line;
}

/* 장식 원 */
.deco-circle {
  position: absolute;
  bottom: -500px;
  left: -280px;
  z-index: 0;
  width: 800px;
  height: 800px;
  border-radius: 50%;
  background: var(--sub-color);
}

/* ========== 모바일 반응형 ========== */
@media (max-width: 768px) {
  .premium-section {
    height: auto;
    min-height: 100svh;
    flex-direction: column;
    align-items: stretch;
    padding: 60px 0 40px;
    overflow: hidden;
    max-width: 100vw;
  }

  .premium-left {
    padding: 0 24px;
    gap: 24px;
  }

  .text-line {
    font-size: 18px;
    line-height: 1.5;
  }

  .text-eng {
    font-size: 11px;
    letter-spacing: 2px;
    margin-top: 8px;
  }

  .slide-progress {
    gap: 10px;
  }

  .slide-btn {
    font-size: 16px;
    padding: 8px;
    min-width: 36px;
    min-height: 36px;
  }

  .slide-current,
  .slide-total {
    font-size: 12px;
  }

  .banner-slider {
    margin-left: 0;
    margin-top: 24px;
    padding: 0 24px;
    width: 100%;
    box-sizing: border-box;
  }

  .banner-track {
    gap: 24px;
  }

  .banner-card {
    width: calc(100vw - 48px);
    height: 400px;
    border-radius: 16px;
    flex-shrink: 0;
  }

  .banner-content {
    padding: 20px 20px 28px;
    background: linear-gradient(to top, rgba(255,255,255,0.95) 70%, transparent);
  }

  .banner-title {
    font-size: 18px;
    margin-bottom: 8px;
  }

  .banner-desc {
    font-size: 13px;
    line-height: 1.5;
  }

  /* VIEW 버튼 모바일에서 숨김 - 터치 스와이프로 대체 */
  .view-btn {
    display: none;
  }

  .deco-circle {
    display: none;
  }
}
</style>
